enum MenuOrder {
  Default = 'Standardní',
  Favorite = 'Oblíbené',
  Healthy = 'Zdravé',
  CookedDate = 'Podle data vaření',
  Custom = 'Vlastní',
}

export default MenuOrder;
